module.exports = __webpack_public_path__ + "static/media/plantPal2_04.573655c5.gif";